
import moment from 'moment';
import {getRequestParams} from "./auth";
import {action, isTalkJoy} from "@/appApi";

/*分数转星星*/
export function scoreToStar(score: number) {
    let starLevel = 3;
    if (score <= 0) {
        starLevel = 0;
    } else if (score < 30) {
        starLevel = 0.5
    } else if (score < 40) {
        starLevel = 1;
    } else if (score < 60) {
        starLevel = 1.5;
    } else if (score < 70) {
        starLevel = 2;
    } else if (score < 80) {
        starLevel = 2.5
    }
    return starLevel;
}

export function getPx(px: number) {
    const htmlWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (htmlWidth >= 600) {
        return px / 750 * (htmlWidth / 2)
    }
    return px / 750 * htmlWidth
}

/*拆分小数点函数*/
export function formatPrice(price: number) {
    const newPrice = price / 100;
    const priceStr = String(newPrice);
    const arr = priceStr.split('.');
    return arr;
}

export function pxToRem(content: string) {
    content = content.replace(/(\d+)px/g, function(s, t) {s = s.replace('px', '');
        const value = parseInt(s) * 0.02667;
        return value + "rem";
    });
    return content;
}


export function formatSeconds(value: number) {
    // eslint-disable-next-line
    // @ts-ignore
    let theTime = parseInt(value);// 需要转换的时间秒
    let theTime1 = 0;// 分
    let theTime2 = 0;// 小时
    let theTime3 = 0;// 天
    if(theTime > 60) {
        // eslint-disable-next-line
        // @ts-ignore
        theTime1 = parseInt(theTime / 60);
        // eslint-disable-next-line
        // @ts-ignore
        theTime = parseInt(theTime % 60);
        if(theTime1 > 60) {
            // eslint-disable-next-line
            // @ts-ignore
            theTime2 = parseInt(theTime1/60);
            // eslint-disable-next-line
            // @ts-ignore
            theTime1 = parseInt(theTime1%60);
            if(theTime2 > 24){
                //大于24小时
                // eslint-disable-next-line
                // @ts-ignore
                theTime3 = parseInt(theTime2/24);
                // eslint-disable-next-line
                // @ts-ignore
                theTime2 = parseInt(theTime2%24);
            }
        }
    }
    let result = '';
    if(theTime > 0){
        // eslint-disable-next-line
        // @ts-ignore
        result = ""+parseInt(theTime)+"秒";
    }
    if(theTime1 > 0) {
        // eslint-disable-next-line
        // @ts-ignore
        result = ""+parseInt(theTime1)+"分"+result;
    }
    if(theTime2 > 0) {
        // eslint-disable-next-line
        // @ts-ignore
        result = ""+parseInt(theTime2)+"小时"+result;
    }
    if(theTime3 > 0) {
        // eslint-disable-next-line
        // @ts-ignore
        result = ""+parseInt(theTime3)+"天"+result;
    }
    return result;
}

export function formatSecond(seconds: number) {
    const date = new Date(seconds * 1000);
    const mm = date.getUTCMinutes();
    const ss = date.getSeconds();
    return (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
}

export function formatSecondsTwo(value: number) {
    let result: any = value;
    const h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
    const m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
    const s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
    result = `${h}:${m}:${s}`
    return result
}

// 清除地址栏中的sessionid
export function notSessionIdUrl(referer: string) {
    let host:any = referer.split('?');
    host = host[0];
    const params = getRequestParams(referer);
    let n = 0;
    for(const i in params) {
        if (i !== 'sessionid') {
            host = `${host}${n===0?'?':'&'}${i}=${params[i]}`
        }
        n++;
    }
    return host;
}

// 当前APP中需要登陆
export function currentNeedLoginUrl(currentPageUrl: string) {
    const url = notSessionIdUrl(currentPageUrl);
    const comm = {
        command:"openview",
        needloginalert: "true",
        needcloseself: true,
        url
    }
    action(comm);
}

// 数字前后加起来只显示4位数,单位为W
export function fourUnit(num: number) {
    // num = 9999999;
    let n: any = num;
    if (num >= 10000) {
        n = num / 10000;
        const index =  String(n).indexOf('.');
        if ( index !== -1 && index < 4) {
            const decimal = String(n).substr(index + 1, 1);
            n = Math.floor(n);
            n = Number(n + '.' + decimal) + 'w';
        } else {
            n = Math.floor(n);
            n = n + 'w';
        }
    }
    return n;
}


export function TalkAppver() {

    // let ua = 'UA: Mozilla/5.0 (Linux; Android 10; MI 8 Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.101 Mobile Safari/537.36 NBDIYI/Android/9.6/defaultChannel'
    let ua = navigator.userAgent;
    ua = ua.toLocaleUpperCase();
    // let index = ua.search(/NBDIYI/);
    const index = ua.search(/TALKJOY/);
    if (index === -1) {
        return 0;
    }
    const cont = ua.substr(index).split('/')[2];
    const ver = cont.split('.');
    let version = '';
    ver.forEach((item)=> {
        if (Number(item) < 10) {
            version = version + '0' + item ;
        } else {
            version = version + item
        }
    })
    if (ver.length <3) {
        version = version + '00'
    }
    return Number(version);
}

export function appver() {

    // let ua = 'UA: Mozilla/5.0 (Linux; Android 10; MI 8 Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.101 Mobile Safari/537.36 NBDIYI/Android/9.6/defaultChannel'
    let ua = navigator.userAgent;
    ua = ua.toLocaleUpperCase();
    let index = ua.search(/NBDIYI/);
    // const talkJoyIndex = ua.search(/TALKJOY/);
    if (isTalkJoy()) {
      index = ua.search(/TALKJOY/);
    }
    if (index === -1) {
        return 0;
    }
    const cont = ua.substr(index).split('/')[2];
    const ver = cont.split('.');
    let version = '';
    ver.forEach((item)=> {
        if (Number(item) < 10) {
            version = version + '0' + item ;
        } else {
            version = version + item
        }
    })
    if (ver.length <3) {
        version = version + '00'
    }
    return Number(version);
}


// 防抖函数
export function debounce(func: any, wait: number) {
    let timeout: any;
    return function(...args: any) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            func.apply(this, args);
        }, wait);
    }
}

/**
 * 判断给定的年级是否在指定的年级范围内。
 *
 * @param {string} grade - 要检查的年级。
 * @param {string[]} gradeRange - 包含年级范围的数组，格式为 "min-max"。
 * @returns {boolean} - 如果年级在范围内返回 true，否则返回 false。
 *
 * @example
 * inGradeRange('1a', ['1-3', '6-7']); // 返回 true
 * inGradeRange('8a', ['1-2', '4-5', '7-9']); // 返回 true
 */
export function inGradeRange(grade: string, gradeRange: string[]): boolean {
    // 取 1a 的 1
    if (grade) {
        const gradeNum = parseInt(grade.slice(0, -1));
        for (const range of gradeRange) {
            const [min, max] = range.split('-').map(Number);
            if (gradeNum >= min && gradeNum <= max) {
                return true;
            }
        }
        return false;
    } else {
        return false;
    }
}

/**
 * 清除末尾是<p><br/></p>结尾的
 */
export function cleanEndEmptyP(str: string) {
    // 使用正则表达式判断字符串是否以 <p><br/></p> 结尾
    const regex = /<p><br\/?><\/p>$/;
    // 如果匹配，则返回去掉结尾的字符串
    if (regex.test(str)) {
        return str.replace(regex, '');
    }
    // 如果不匹配，返回原字符串
    return str;
}

// 判断是否是横屏
export function isLandscape() {
    return window.innerWidth > window.innerHeight;
}
